import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appInputTitleCase]',
    standalone: false
})
export class InputTitleCaseDirective {

  isDesktop : boolean = false
  constructor(private el: ElementRef) {
    let device = navigator.userAgent
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
      // true for mobile device
    }else{
      // false for not mobile device
      this.isDesktop = true
    }
   }

  @HostListener('keydown') onKeyDown() {

    if (this.el.nativeElement.value && this.isDesktop) {
      const arr: string[] = this.el.nativeElement.value.split('');
      arr[0] = arr[0].toUpperCase();
      this.el.nativeElement.value = arr.join('');
   }else{
     
   }
  }

}
